export const dataLayerPush = (data: object) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};
